import React, { useState, useEffect } from "react";
import { getCommonUtilsApi, updateCommonUtilsApi } from "Services/allApi";
import { toast, ToastContainer } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css';

function InputBox() {
  const [data, setData] = useState({
    main_phone_number: '',
    whatsapp_number: '',
    expert_tainers_count: 0,
    total_modules: 0,
    year_of_experience: 0,
    Technologies_count: 0,
    Companies_count: 0,
    google_reviews_count: 0,
    tatal_couses_count: 0,
    placements: 0,
    instagram_url: '',
    youtube_url: '',
    facebook_url: '',
    linkdin_url: ''
  });
  const [commonutils_id, setCommonutilsId] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state

  const labelMapping = {
    main_phone_number: 'Main Phone Number',
    whatsapp_number: 'WhatsApp Number',
    expert_tainers_count: 'Expert Trainers Count',
    total_modules: 'Total Modules',
    year_of_experience: 'Years of Experience',
    Technologies_count: 'Technologies Count',
    Companies_count: 'Companies Count',
    google_reviews_count: 'Google Reviews Count',
    tatal_couses_count: 'Total Courses Count',
    placements: 'Placements',
    instagram_url: 'Instagram URL',
    youtube_url: 'YouTube URL',
    facebook_url: 'Facebook URL',
    linkdin_url: 'LinkedIn URL'
  };

  const typeOfNumber = [
    "expert_tainers_count",
    "total_modules",
    "year_of_experience",
    "Technologies_count",
    "Companies_count",
    "google_reviews_count",
    "tatal_couses_count",
    "placements"
  ];

  const typeOfUrl = [
    "instagram_url",
    "youtube_url",
    "facebook_url",
    "linkdin_url"
  ];

  const fetchData = async () => {
    setLoading(true); // Set loading to true while fetching data
    try {
      const result = await getCommonUtilsApi();
      const fetchedData = result.data.CommonUtil;
      setData(fetchedData);
      setCommonutilsId(fetchedData.id);
    } catch (error) {
      console.error("Failed to fetch data", error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false); // Set loading to false after data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateFields = () => {
    for (const key in data) {
      if (data[key] === '' || data[key] === null || data[key] === undefined) {
        toast.error(`Please fill in the field: ${labelMapping[key] || key.replace(/_/g, ' ')}`);
        return false;
      }
    }
    return true;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateFields()) return;

    setLoading(true); // Set loading to true while saving data
    try {
      if (commonutils_id) {
        const updatedData = await updateCommonUtilsApi(commonutils_id, data);
        if (updatedData && !updatedData.error) {
          toast.success("Data updated successfully!");
        } else {
          toast.error("Failed to update data: " + updatedData?.message || "Unknown error");
        }
      } else {
        toast.error("commonutils_id is missing");
      }
    } catch (error) {
      console.error("Error saving data:", error.message);
      toast.error("Error saving data: " + error.message);
    } finally {
      setLoading(false); // Set loading to false after saving data
    }
  };

  const handleCancel = () => {
    fetchData();
  };

  // Check if data is empty (excluding 'id')
  const isDataEmpty = Object.values(data).every(value => value === '' || value === 0 || value === null);

  return (
    <div className=" dark:!bg-navy-700 dark:text-white">
      {loading ? (
        // Show the loading message when loading is true
        <div className="loading-message text-purple-500 mt-6 text-center">Loading...</div>
      ) : isDataEmpty ? (
        // Show a message when data is empty
        <div className="no-data-message mt-6 text-red-500 text-center">No data available</div>
      ) : (
        <form onSubmit={handleSave} className="h-full w-full p-8">
          <div className="space-y-12">
            <div className="border-b border-gray-900/10 pb-6"></div>
            <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 ">
              {Object.keys(data).filter(key => key !== 'id').map((key) => (
                <div key={key} className="sm:col-span-1">
                  <label htmlFor={key} className="block font-medium text-gray-900 dark:text-white">
                    {labelMapping[key] || key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}
                  </label>
                  <input
                    name={key}
                    type={typeOfNumber.includes(key) ? "number" : typeOfUrl.includes(key) ? "url" : "text"}
                    value={data[key]}
                    onChange={handleChange}
                    className="mt-2 block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 dark:bg-[#0b14374d] dark:text-white dark:border-gray-600"
                  />
                </div>
              ))}
            </div>
            <div className="mt-6 flex items-center justify-end gap-x-6">
              <button
                type="button"
                onClick={handleCancel}
                className="bg-gray-500 text-white px-4 py-2 rounded-lg font-medium text-sm hover:bg-gray-400 ml-2 hover:text-purple-800"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="rounded-md bg-purple-800 px-3 py-2 text-lg font-semibold text-white shadow-sm hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-600"
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        </form>
      )}
      <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
    </div>
  );
}

export default InputBox;